import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { ConfigurationService, HttpService } from '@sdbn/appclient';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { ValidationMessage, ValidationMessageType } from '@sdbn/appclient';

export class ScanBarcodeController extends AbstractStepController {

    httpService: HttpService;

    configurationService: ConfigurationService;

    constructor() {
      super();
      this.httpService = WizardServiceLocator.injector.get(HttpService);
      this.configurationService = WizardServiceLocator.injector.get(ConfigurationService);
    }

    onContextChange(contextChange: ContextChange) {
      if (contextChange.key === 'barcodeScanned') {
        const scannedBarcode = this.dashboardContext.getContextValue('barcodeScanned');
        if (scannedBarcode == null) {

        } else {
          const config = this.wizardComponent.currentStep.dashboardConfiguration?.barcodeMapping;
          for (const key of Object.keys(config)) {
            console.log('find by key', key, config[key]);
            if ( ('' + scannedBarcode).startsWith(key)) {
              this.wizardComponent.next(config[key]);
              return;
            }
          }
          const msg = ValidationMessage.createWithData(ValidationMessageType.ERROR, 'tmc-yard.widgets.registration-terminal.barcode-scan.barcode-not-processable');
          this.dashboardContext.setContextValue('validationMessage', msg);
        }
      }
    }

    onRegisterToDashboardContext() {
      const qrCodeScanner = this.configurationService.getDeviceParam('qrcode-scanner');
      console.log('Barcode.onRegister', qrCodeScanner);
      if (qrCodeScanner?.value === 'webcam') {
        const qrCodeScannerWebWidget = this.wizardComponent.currentStep.dashboardConfiguration?.qrCodeScannerWebWidget;
        console.log('Barcode.onRegister: Use webcam widget', qrCodeScannerWebWidget);
        this.wizardComponent.currentStep.contentIdentifier = qrCodeScannerWebWidget;
      }
    }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('receive code started');

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {
      const matDialog = WizardServiceLocator.injector.get(MatDialog);
      const dialogData: ConfirmDialogData = {
          titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
          messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
          confirm: () => {
              this.wizardComponent.stopInactivityMonitoring();
              this.wizardComponent.restartWizard();
          }
      };
      matDialog.open(ConfirmDialogComponent, {
          data: dialogData
      });
    }

    getControls(): StepControl[] {
      const dashboardConfiguration = this.wizardComponent.currentStep.dashboardConfiguration;

      const controls = new Array<StepControl>();

      if (dashboardConfiguration?.hidePreviousAction == null || dashboardConfiguration?.hidePreviousAction === false) {
        const previousControl = new StepControl();
        previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
        previousControl.type = StepControlType.BUTTON_STROKED;
        previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
        previousControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            this.wizardComponent.previous();
        };
        controls.push(previousControl);
      }

      let spacer = new StepControl();
      spacer.type = StepControlType.SPACER_GROW;
      controls.push(spacer);

      const cancelControl = new StepControl();
      cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
      cancelControl.type = StepControlType.BUTTON_STROKED;
      cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
      cancelControl.controlAction = this.cancel.bind(this);
      controls.push(cancelControl);

      if (dashboardConfiguration?.hideNextAction == null || dashboardConfiguration?.hideNextAction === false) {

        spacer = new StepControl();
        spacer.type = StepControlType.SPACER;
        controls.push(spacer);

        const newRegistrationControl = new StepControl();
        if (dashboardConfiguration != null && dashboardConfiguration.nextProcessStep != null) {
          newRegistrationControl.labelDictionaryKey = dashboardConfiguration.nextProcessStep.labelDictionaryKey;
          newRegistrationControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            this.wizardComponent.next(dashboardConfiguration.nextProcessStep.key);
          };
        } else {
          newRegistrationControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.button.alternative';
          newRegistrationControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            this.wizardComponent.next();
          };
        }
        newRegistrationControl.type = StepControlType.BUTTON_STROKED;
        newRegistrationControl.iconAfterCss = 'fa-thin fa-angle-right';
        controls.push(newRegistrationControl);
      }

      return controls;
    }
}
